export enum Status {
  STATUS_TYPE_BID_CREATION_COMPLETED = 1,
  STATUS_TYPE_BID_DECISION_NO_BID = 2,
  STATUS_TYPE_BID_DECISION_COMPLETED = 3,
  STATUS_TYPE_BID_DECISION_DIRECTOR_SIGN_OFF_REQUIRED = 4,
  STATUS_TYPE_BID_SPECIFICATION_SAVED = 5,
  STATUS_TYPE_BID_SPECIFICATION_COMPLETED = 6,
  STATUS_TYPE_REVERTED_TO_BID_SPECIFICATION = 7,
  STATUS_TYPE_BID_COSTINGS_COMPLETED = 8,
  STATUS_TYPE_REVERTED_TO_BID_COSTINGS = 9,
  STATUS_TYPE_BID_REVIEW_COMPLETED = 10,
  STATUS_TYPE_BID_REVIEW_DIRECTOR_SIGN_OFF_REQUIRED = 11,
  STATUS_TYPE_FEE_SENT_TO_CRM = 12,
  STATUS_TYPE_BID_TENDER_COMPLETED = 13,
  STATUS_TYPE_PROJECT_CANCELLED = 14,
  STATUS_TYPE_LOST = 15,
  STATUS_TYPE_PROJECT_NEW_LIVE_PROJECT = 16,
  STATUS_TYPE_PROJECT_ASSIGNED = 17,
  STATUS_TYPE_PROJECT_STARTUP = 18,
  STATUS_TYPE_PROJECT_PLANNING = 19,
  STATUS_TYPE_PROJECT_LHA_PERMISSIONS = 20,
  STATUS_TYPE_PROJECT_SITEWORKS = 21,
  STATUS_TYPE_PROJECT_DATA = 22,
  STATUS_TYPE_PROJECT_POST_DELIVERY = 23,
  STATUS_TYPE_PROJECT_COMPLETED = 24,
  STATUS_TYPE_PROJECT_ON_HOLD = 25,
  STATUS_TYPE_PROJECT_QA_TEAM = 26,
}

export enum Decision {
  DECISION_TYPE_BID_DECISION_NO_BID = 'decision_no_bid',
  DECISION_TYPE_BID_DECISION_COMPLETED = 'decision_completed',
  DECISION_TYPE_BID_DECISION_DIRECTOR_SIGN_OFF_REQUIRED = 'decision_director_sign_off_required',
}

export enum ManagementStatus {
  STATUS_TYPE_BID = 1,
  STATUS_TYPE_LIVE = 2,
  STATUS_TYPE_CANCELLED = 3,
  STATUS_TYPE_ALL = 4,
}
